/* Sidekick Dental Powder page: purchase selector, gallery and sticky CTA.
   Prices and plan ids are rendered by Liquid from the real product data;
   this script only switches between them and fills the product form. */
(function () {
  if (window.SKD) return;

  var SKD = (window.SKD = {
    state: { mode: 'sub', qty: 1, extra: false, xvar: null },
    set: function (patch) {
      for (var k in patch) SKD.state[k] = patch[k];
      document.dispatchEvent(new CustomEvent('skd:state', { detail: SKD.state }));
    },
  });

  /* Shopify money format, for prices that change on the page (extras total). */
  function money(cents, fmt) {
    cents = Math.round(cents || 0);
    fmt = fmt || '${{amount}}';
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    var withSep = function (sep, dec) { return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (dec ? dec + parts[1] : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return withSep('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return withSep(',', '.');
    });
  }
  SKD.money = money;

  /* ---------------- Purchase selector ---------------- */
  class SkdBuy extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.idInput = this.querySelector('input[name="id"]');
      this.planInput = this.querySelector('input[name="selling_plan"]');
      this.ctaText = this.querySelector('.skd-cta > span');
      this.subLabel = this.dataset.subLabel || 'Subscribe now';
      this.onceLabel = this.dataset.onceLabel || 'Add to cart';

      if (this.dataset.primary === 'true') {
        SKD.state.mode = this.dataset.defaultMode === 'once' ? 'once' : 'sub';
        SKD.state.qty = parseInt(this.dataset.defaultQty, 10) || 1;
        /* Links from the advertorial can preselect a pack (?pack=1|2|3) and a mode (?mode=sub|once). */
        try {
          var qs = new URLSearchParams(window.location.search);
          var pk = parseInt(qs.get('pack'), 10);
          if (pk > 0 && this.querySelector('[data-skd-qty][value="' + pk + '"]:not([disabled])')) SKD.state.qty = pk;
          var md = qs.get('mode');
          if (md === 'sub' || md === 'once') SKD.state.mode = md;
        } catch (e) {}
      }

      /* Extras: one add-on product shown under the packs. */
      this.x = this.querySelector('[data-skd-extras]');
      this.giftMin = parseInt(this.dataset.giftMin, 10) || 0;
      if (this.x) {
        this.xCard = this.x.querySelector('.skd-x__card');
        this.xVar = this.x.querySelector('[data-x-variant]');
        this.xBtn = this.x.querySelector('[data-x-toggle]');
        if (!SKD.state.xvar && this.xVar) SKD.state.xvar = this.xVar.value;
        this.xBtn.addEventListener('click', () => {
          if (this.isGift()) return;
          SKD.set({ extra: !SKD.state.extra });
        });
        /* Add the extra as its own line just before the powder is added. */
        this.addEventListener('submit', (e) => this.beforeSubmit(e), true);
      }

      this.addEventListener('change', (e) => {
        var t = e.target;
        if (t.matches('[data-skd-mode]')) SKD.set({ mode: t.value });
        if (t.matches('[data-skd-qty]')) SKD.set({ qty: parseInt(t.value, 10) });
        if (t.matches('[data-x-variant]')) SKD.set({ xvar: t.value });
      });
      document.addEventListener('skd:state', () => this.render());
      this.render();
    }

    isGift() {
      if (!this.x || this.giftMin <= 0 || SKD.state.qty < this.giftMin) return false;
      var o = this.xOption();
      return !!(o && o.dataset.gift);
    }

    xOption() {
      if (!this.xVar) return null;
      if (this.xVar.tagName === 'SELECT') {
        return this.xVar.querySelector('option[value="' + SKD.state.xvar + '"]') || this.xVar.options[0];
      }
      return this.xVar;
    }

    /* Cents the extra adds to this order: 0 when not chosen or when it is the free gift. */
    xCents() {
      if (!this.x || this.isGift() || !SKD.state.extra) return 0;
      var o = this.xOption();
      return Math.max(0, parseInt(o && o.dataset.price, 10) || 0);
    }

    beforeSubmit(e) {
      if (this._xPass) { this._xPass = false; return; }
      var gift = this.isGift();
      if (!gift && !SKD.state.extra) return;
      var o = this.xOption();
      if (!o) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var form = e.target;
      var btn = this.querySelector('.skd-cta');
      if (btn) { btn.classList.add('loading'); btn.setAttribute('aria-disabled', 'true'); }
      var spin = btn && btn.querySelector('.loading__spinner');
      if (spin) spin.classList.remove('hidden');
      var kind = gift ? 'gift' : 'addon';
      var id = parseInt(gift ? o.dataset.gift : o.value, 10);
      var go = () => {
        if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); }
        if (spin) spin.classList.add('hidden');
        this._xPass = true;
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      };
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          /* One extra per order. Keep a matching line; swap an add-on for the gift (or back). */
          var items = cart.items || [];
          var line = 0;
          for (var i = 0; i < items.length; i++) {
            if (items[i].properties && items[i].properties._sk_extra) { line = i + 1; break; }
          }
          var add = function () {
            return fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: { _sk_extra: kind } }] }),
            });
          };
          if (!line) return add();
          if (items[line - 1].properties._sk_extra === kind && items[line - 1].variant_id === id) return null;
          return fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: line, quantity: 0 }),
          }).then(add);
        })
        .catch(function () {})
        .then(go, go);
    }

    paintExtras(mode) {
      if (!this.x) return;
      var gift = this.isGift();
      var on = !gift && SKD.state.extra;
      var o = this.xOption();
      var price = parseInt(o && o.dataset.price, 10) || 0;
      var compare = parseInt(o && o.dataset.compare, 10) || price;
      var fmt = this.dataset.moneyFormat;
      if (this.xVar && this.xVar.tagName === 'SELECT' && SKD.state.xvar && this.xVar.value !== SKD.state.xvar) this.xVar.value = SKD.state.xvar;
      this.xCard.dataset.state = gift ? 'gift' : on ? 'on' : 'off';
      var tab = this.x.querySelector('[data-x-tab]');
      if (tab) tab.textContent = gift ? tab.dataset.gift : tab.dataset.addon;
      var was = this.x.querySelector('[data-x-was]');
      var now = this.x.querySelector('[data-x-now]');
      if (was) {
        was.textContent = money(compare, fmt);
        was.parentElement.hidden = !gift && compare <= price;
      }
      if (now) now.textContent = gift ? 'FREE' : money(price, fmt);
      var label = this.x.querySelector('[data-x-label]');
      if (label) label.textContent = gift ? 'Included' : on ? 'Added' : 'Add';
      this.xBtn.setAttribute('aria-pressed', gift || on ? 'true' : 'false');
      if (gift) this.xBtn.setAttribute('aria-disabled', 'true'); else this.xBtn.removeAttribute('aria-disabled');
      var na = this.x.querySelector('[data-x-note-addon]');
      var ng = this.x.querySelector('[data-x-note-gift]');
      if (na) na.hidden = gift;
      if (ng) ng.hidden = !gift;
    }

    card() {
      return (
        this.querySelector('[data-skd-qty][value="' + SKD.state.qty + '"]') ||
        this.querySelector('[data-skd-qty]')
      );
    }

    render() {
      var s = SKD.state;
      var card = this.card();
      if (!card) return;
      var mode = s.mode === 'sub' && card.dataset.plan ? 'sub' : 'once';
      this.dataset.mode = mode;
      this.querySelectorAll('[data-skd-mode]').forEach(function (r) {
        r.checked = r.value === mode;
      });
      this.querySelectorAll('[data-skd-qty]').forEach(function (r) {
        r.checked = r === card;
      });
      if (this.idInput) this.idInput.value = card.dataset.variant;
      if (this.planInput) {
        if (mode === 'sub') {
          this.planInput.value = card.dataset.plan;
          this.planInput.disabled = false;
        } else {
          this.planInput.value = '';
          this.planInput.disabled = true;
        }
      }
      this.paintExtras(mode);
      var price = mode === 'sub' ? card.dataset.subPrice : card.dataset.oncePrice;
      var extra = this.xCents();
      if (extra > 0) {
        var base = parseInt(mode === 'sub' ? card.dataset.subCents : card.dataset.onceCents, 10) || 0;
        price = money(base + extra, this.dataset.moneyFormat);
      }
      if (this.ctaText) {
        this.ctaText.textContent = (mode === 'sub' ? this.subLabel : this.onceLabel) + ' · ' + price;
      }
      SKD.summary = {
        title: card.dataset.title + (this.isGift() ? ' + free gift' : extra > 0 ? ' + extra' : ''),
        mode: mode,
        price: price,
      };
      document.dispatchEvent(new CustomEvent('skd:summary'));
    }

    submit() {
      var form = this.querySelector('form');
      if (!form) return;
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true }));
    }
  }
  if (!customElements.get('sk-dental-buy')) customElements.define('sk-dental-buy', SkdBuy);

  /* ---------------- Keep app bundle widgets out of this selector ----------------
     A store-wide bundle app injects its own deal picker into the first product form.
     This page has its own pricing, so remove that widget and its hidden line property
     from our forms only. Other product pages are not affected. */
  function stripBundles() {
    document.querySelectorAll('sk-dental-buy kaching-bundle').forEach(function (e) { e.remove(); });
    document.querySelectorAll('sk-dental-buy input[name^="properties[__kaching"]').forEach(function (e) { e.remove(); });
  }
  stripBundles();
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(stripBundles);
    var watchBuys = function () {
      document.querySelectorAll('sk-dental-buy').forEach(function (b) {
        if (!b._skdWatched) { b._skdWatched = true; mo.observe(b, { childList: true, subtree: true }); }
      });
    };
    watchBuys();
    document.addEventListener('DOMContentLoaded', function () { watchBuys(); stripBundles(); });
  }

  /* "Claim free gift" links: pick the smallest pack that earns the gift, then scroll to the
     selector (unless another script, such as the advertorial's smooth scroll, already did). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-skd-gift]');
    if (!a) return;
    var main = document.querySelector('sk-dental-buy[data-primary="true"]') || document.querySelector('sk-dental-buy');
    var min = main ? parseInt(main.dataset.giftMin, 10) || 0 : 0;
    if (min > 0 && SKD.state.qty < min) {
      var ok = main.querySelector('[data-skd-qty][value="' + min + '"]:not([disabled])');
      if (ok) SKD.set({ qty: min });
    }
    if (e.defaultPrevented || !main) return;
    e.preventDefault();
    var y = main.getBoundingClientRect().top + window.pageYOffset - 120;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });

  /* "Choose Subscribe & Save" links: switch the selector to subscription and scroll to it. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-skd-choose]');
    if (!a) return;
    e.preventDefault();
    SKD.set({ mode: a.dataset.skdChoose === 'once' ? 'once' : 'sub' });
    var main = document.querySelector('sk-dental-buy[data-primary="true"]');
    if (main) {
      var y = main.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: y, behavior: 'smooth' });
      setTimeout(function () {
        if (Math.abs(main.getBoundingClientRect().top - 120) > 300) window.scrollTo(0, y);
      }, 900);
    }
  });

  /* ---------------- Gallery ---------------- */
  class SkdGallery extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.track = this.querySelector('.skd-gallery__track');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.skd-gallery__slide'));
      this.marks = Array.prototype.slice.call(this.querySelectorAll('[data-goto]'));
      this.prev = this.querySelector('.skd-gallery__arrow--prev');
      this.next = this.querySelector('.skd-gallery__arrow--next');
      this.index = 0;
      var self = this;
      this.marks.forEach(function (b) {
        b.addEventListener('click', function () {
          self.go(parseInt(b.dataset.goto, 10));
        });
      });
      if (this.prev) this.prev.addEventListener('click', function () { self.go(self.index - 1); });
      if (this.next) this.next.addEventListener('click', function () { self.go(self.index + 1); });
      var t;
      this.track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var w = self.track.clientWidth || 1;
          self.setIndex(Math.round(self.track.scrollLeft / w));
        }, 60);
      }, { passive: true });
      this.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index - 1); }
      });
      this.setIndex(0);
    }
    go(i) {
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
      this.setIndex(i);
    }
    setIndex(i) {
      this.index = i;
      this.marks.forEach(function (b) {
        b.setAttribute('aria-current', parseInt(b.dataset.goto, 10) === i ? 'true' : 'false');
      });
      if (this.prev) this.prev.disabled = i === 0;
      if (this.next) this.next.disabled = i === this.slides.length - 1;
      var thumb = this.querySelector('.skd-gallery__thumb[data-goto="' + i + '"]');
      if (thumb && thumb.parentElement) {
        var p = thumb.parentElement;
        var left = thumb.offsetLeft - p.clientWidth / 2 + thumb.clientWidth / 2;
        p.scrollTo({ left: left, behavior: 'smooth' });
      }
    }
  }
  if (!customElements.get('sk-dental-gallery')) customElements.define('sk-dental-gallery', SkdGallery);

  /* ---------------- Sticky CTA (mobile) ---------------- */
  class SkdSticky extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.btn = this.querySelector('button');
      this.titleEl = this.querySelector('[data-sticky-title]');
      this.priceEl = this.querySelector('[data-sticky-price]');
      this.watch = Array.prototype.slice.call(document.querySelectorAll('sk-dental-buy'));
      this.inView = new Map();
      this.passed = false;
      this.btn.addEventListener('click', function () {
        var main = document.querySelector('sk-dental-buy[data-primary="true"]');
        if (main) main.submit();
      });
      document.addEventListener('skd:summary', function () { self.paint(); });
      this.paint();
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          self.inView.set(en.target, en.isIntersecting);
          if (en.target.dataset.primary === 'true' && !en.isIntersecting) {
            self.passed = en.boundingClientRect.top < 0;
          }
        });
        self.toggle();
      }, { threshold: 0 });
      this.watch.forEach(function (el) {
        var cta = el.querySelector('.skd-cta') || el;
        cta.dataset.primary = el.dataset.primary;
        io.observe(cta);
      });
      /* A fast scroll can jump right over the button without the observer seeing it,
         so also settle "passed" from the button's position whenever scrolling stops. */
      var primaryCta = null;
      this.watch.forEach(function (el) { if (el.dataset.primary === 'true') primaryCta = el.querySelector('.skd-cta'); });
      var tick = null;
      window.addEventListener('scroll', function () {
        clearTimeout(tick);
        tick = setTimeout(function () {
          if (!primaryCta) return;
          var r = primaryCta.getBoundingClientRect();
          var vis = r.bottom > 0 && r.top < window.innerHeight;
          self.inView.set(primaryCta, vis);
          if (!vis) self.passed = r.top < 0;
          self.toggle();
        }, 120);
      }, { passive: true });
    }
    toggle() {
      var anyVisible = false;
      this.inView.forEach(function (v) { if (v) anyVisible = true; });
      var show = this.passed && !anyVisible;
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      /* The free gift strip rides on top of this bar on phones, and floats on its own on desktop. */
      var bar = document.querySelector('.skd-giftbar');
      if (bar) {
        var h = show && window.matchMedia('(max-width: 989px)').matches ? this.offsetHeight : 0;
        document.documentElement.style.setProperty('--skd-sticky-h', h + 'px');
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.tabIndex = show ? 0 : -1;
      }
    }
    paint() {
      var s = SKD.summary;
      if (!s) return;
      if (this.titleEl) this.titleEl.textContent = s.title + (s.mode === 'sub' ? ', delivered monthly' : ', one-time');
      if (this.priceEl) this.priceEl.textContent = s.price;
      if (this.btn) this.btn.textContent = s.mode === 'sub' ? 'Subscribe' : 'Add to cart';
    }
  }
  if (!customElements.get('sk-dental-sticky')) customElements.define('sk-dental-sticky', SkdSticky);
})();
